<template>
  <li
    class="dropdown__item"
    :class="[customClass, { selected }]"
    @click="$emit('click')"
  >
    <component v-if="icon" :is="icon" class="dropdown__icon"/>
    <slot/>
  </li>
</template>
<script>
export default {
  props: {
    icon: String,
    customClass: {
      type: [String, Array, Object],
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import "~styles/shared/dropdown.scss";
</style>;
